import { ImgIframeSx } from './AbaWebSx'
import Iframe from 'react-iframe'
import abaWebBorrada from "../../../Assets/Imgs/aba-web-borrada.jpeg"

const AbaWeb = ({ link }) => {
    return (
        <>
            {link
                ? <Iframe
                    url={`${link}`}
                    start
                    width="100%"
                    height="100%"
                    display="block"
                    position="relative"
                    id="iframe"
                    className="testee" />
                : <img src={abaWebBorrada} alt="Erro ao carregar a imagem" style={ImgIframeSx} />
            }
        </>
    )
}

export default AbaWeb
